<template>
  <div class="content Tabs">

    <b-tabs card  v-model="tabIndex">

      <b-tab :title="lang.tab_Parts"  :title-link-class="textColors" :title-item-class="textColors" >
        <p v-show="isAggregated == 'true'">{{lang.infotext_1}}:</p>
        <p v-show="isAggregated == 'false'">{{lang.infotext_2}}:</p>

        <BomPartsTableComponent v-show="isAggregated == 'true'" :lang="lang.PartsTable" :tabIndex="tabIndex"></BomPartsTableComponent>
        <BomPartsAggregatedTableComponent v-show="isAggregated == 'false'" :lang="lang.PartsTable" :tabIndex="tabIndex"></BomPartsAggregatedTableComponent>
        <br><br>
        <b-form-checkbox 
          v-show="isBom"
          id="isAggregatedCheckbox"
          v-model="isAggregated"
          name="isAggregatedCheckbox"
          value="false"
          unchecked-value="true"
        >
          {{lang.checkbox_Aggregated}}
        </b-form-checkbox>
      </b-tab>
      <b-tab :title="lang.tab_PartsAlternative"  :title-link-class="textColors" :title-item-class="textColors" >
        <p>{{lang.infotext_3}}:</p>
        <BomPartsAlternativeTableComponent :lang="lang.PartsAlternativeTable" :tabIndex="tabIndex"></BomPartsAlternativeTableComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_ExtendedBom"  :title-link-class="textColors" :title-item-class="textColors" >
        <p>{{lang.infotext_4}}:</p>
        <BomExtendedTableComponent :lang="lang.ExtendedBom" :tabIndex="tabIndex"></BomExtendedTableComponent>
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_UsedLibraries" :title-link-class="textColors" :title-item-class="textColors">
        <p>{{lang.infotext_5}}:</p>
        <UsedLibrariesInBomComponent :lang="lang.UsedLibraries" :tabIndex="tabIndex"></UsedLibrariesInBomComponent>
      </b-tab>
      <!-- <b-tab :title="lang.tab_Documents"  :title-link-class="textColors" :title-item-class="textColors" :active="isReturningFromImport">
        <p>{{lang.infotext_6}}:</p>
        <DocumentsComponent :lang="lang.DocumentsTable"></DocumentsComponent>
      </b-tab> -->
      

    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'

import BomPartsTableComponent from '@/components/shared/BomPartsTableComponent'
import BomPartsAlternativeTableComponent from '@/components/shared/BomPartsAlternativeTableComponent'
import BomPartsAggregatedTableComponent from '@/components/shared/BomPartsAggregatedTableComponent'
import DocumentsComponent from '@/components/shared/DocumentsComponent'
import BomExtendedTableComponent from '@/components/shared/BomExtendedTableComponent'
import UsedLibrariesInBomComponent from '@/components/shared/UsedLibrariesInBomComponent'

export default {
  name: "Content",
  components: {
    BomPartsTableComponent,
    BomPartsAlternativeTableComponent,
    BomPartsAggregatedTableComponent,
    DocumentsComponent,
    BomExtendedTableComponent,
    UsedLibrariesInBomComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      isAggregated: "false",
      isBom: false,
      tabIndex: 0,
      file: null,
    }
  },
  computed: {
     ...mapGetters({

      appConf: 'appConf',
    }),
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {
    
    


  
  },
  mounted(){
    
  },
  updated() {
    
    
  },
  watch: {
    tabIndex: function(newVal, oldVal){

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
      this.$parent.$parent.$parent.switchButtons(newVal);
    },
  },
  methods: {
    
  }
}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectBom/Middle/Content/Content.vue